export default {
  type: '',
  tax_number: '',
  name: '',
  kpp: '',
  counterparty: {
    type: '',
    name: '',
    tax_number: '',
    kpp: '',
  },
  contract: {
    number: null,
    date: null,
    type: '',
    amount: null,
    subject_type: '',
    action_type: '',
    is_charge_paid_by_agent: false,
    type_description: '',
    subject_type_description: '',
    action_type_description: '',
  },
  filling_type: null,
}
